const slotsValid = [{}, {}];
export const slots = [
  {
    dfpNetworkId: '78780000',
    adUnit: 'branding_top',
    sizes: [[1, 1], [728, 90], [1100, 120], [980, 90], 'fluid'],
    slotId: 'div-gpt-ad-1514298874616-0',
  },
  {
    dfpNetworkId: '78780000',
    adUnit: 'desktop_premium',
    sizes: [[300, 400], [300, 600], [300, 250]],
    slotId: 'div-gpt-ad-1510239331518-1',
  },
  {
    dfpNetworkId: '78780000',
    adUnit: 'desktop_right_sidebar',
    sizes: [[300, 250]],
    slotId: 'div-gpt-ad-1510224251147-0',
  },
  {
    dfpNetworkId: '78780000',
    adUnit: 'desktop_context',
    sizes: [[728, 90], 'fluid'],
    slotId: 'div-gpt-ad-1510239331518-2',
  },
  {
    dfpNetworkId: '78780000',
    adUnit: 'ab_desktop_content-roll',
    sizes: [[670, 200], [670, 380]],
    slotId: 'div-gpt-ad-1573820960067-0',
  },
  {
    dfpNetworkId: '78780000',
    adUnit: 'mobile_web_premium',
    sizes: ['fluid', [300, 250], [300, 600], [300, 400]],
    slotId: 'div-gpt-ad-1510224093566-3',
  },
  {
    dfpNetworkId: '78780000',
    adUnit: 'mobile_web_bottom',
    sizes: [[320, 100], [320, 50], [300, 250], 'fluid'],
    slotId: 'div-gpt-ad-1548957160695-0',
  },
  {
    dfpNetworkId: '78780000',
    adUnit: 'ab_mobile_content-roll',
    sizes: [[345, 200]],
    slotId: 'div-gpt-ad-1573834860031-0',
  },
  {
    dfpNetworkId: '78780000',
    adUnit: 'ab_mobile_web_catfish',
    sizes: [],
    slotId: 'div-gpt-ad-1510224093566-0',
  },
  {
    dfpNetworkId: '78780000',
    adUnit: 'mobile_web_top',
    sizes: [[320, 50], [320, 100], 'fluid'],
    slotId: 'div-gpt-ad-1575022787355-0',
  },
].map(a => {
  if (!slotsValid[0][a.adUnit] && !slotsValid[1][a.slotId]) {
    slotsValid[0][a.adUnit] = true;
    slotsValid[1][a.slotId] = true;
    return a;
  }
  throw console.error(a.adUnit, a.slotId, 'repeated');
});
export const ignoreTopBanner = [
  '/registration/',
  '/registration',
  '/login/',
  '/login',
  '/my/',
  '/my',
  '/recovery',
  '/recovery/',
  '/my/zapchasti',
  '/my/zapchasti/',
  '/messages',
  '/messages/',
  '/favorites',
  '/favorites/',
  '/billing',
  '/billing/',
  '/profile',
  '/profile/',
  '/my/moto',
  '/my/moto/',
  '/my/avtobus',
  '/my/avtobus/',
  '/my/gruzovye',
  '/my/gruzovye/',
  '/my/spetstehnika',
  '/my/spetstehnika/',
  '/my/pritsepy',
  '/my/pritsepy/',
  '/my/zapchasti',
  '/my/zapchasti/',
  '/add/avto',
  '/add/avto/',
  '/add/moto/',
  '/add/moto',
  '/add/avtobus',
  '/add/avtobus/',
  '/add/gruzovye',
  '/add/gruzovye/',
  '/add/spetstehnika',
  '/add/spetstehnika/',
  '/add/pritsepy',
  '/add/pritsepy/',
  '/add/zapchasti',
  '/add/zapchasti/',
  '/insurance/orders',
  '/insurance/orders/',
  '/dialogs',
  '/dialogs/',
  '/service/search-subscriptions',
  '/service/search-subscriptions/',
];



// WEBPACK FOOTER //
// ./src/shared/modules/googletag/store.js